import React from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import useSearchState from "./useSearchState";
import { Puff } from "react-loader-spinner";
import { NoSearchResults } from "./NoSearchResults";
import useSearch from "./useSearch";

interface SearchResultsProps<TRow> {
	columns: TableColumn<TRow>[];
	onRowClick: (row: TRow) => void;
	paginationServer?: boolean;
	rowsPerPageText?: string;
	selectAllRowsItem?: boolean;
}

export function SearchResults<TRow>({
	columns,
	onRowClick,
	paginationServer = false,
	rowsPerPageText,
	selectAllRowsItem = true,
}: SearchResultsProps<TRow>) {
	const { data, loading, error, resultsTotal } = useSearchState();
	const {
		onChangeResultsPage,
		onChangeResultsPerPage,
		onChangeResultsSort,
		onChangeResultsSortDirection,
	} = useSearch();

	return (
		<DataTable
			columns={columns}
			data={data}
			highlightOnHover={true}
			onRowClicked={onRowClick}
			noDataComponent={<NoSearchResults error={error} />}
			pagination={true}
			paginationServer={paginationServer}
			paginationTotalRows={resultsTotal}
			paginationComponentOptions={{
				rowsPerPageText,
				selectAllRowsItem,
			}}
			onChangePage={onChangeResultsPage}
			onChangeRowsPerPage={onChangeResultsPerPage}
			sortServer={paginationServer}
			onSort={(col, dir) => {
				onChangeResultsSort(col.sortField);
				onChangeResultsSortDirection(dir);
				onChangeResultsPage(1);
			}}
			persistTableHead={true}
			pointerOnHover={true}
			progressPending={loading}
			progressComponent={
				<Puff color="#00BFFF" height={100} width={100} radius={500} />
			}
			striped={true}
		/>
	);
}
